<template>
    <ds-tooltip
        :disabled="disableTooltip"
        :is-open="isTooltipOpen"
        :position="tooltipPosition"
    >
        <template #reference>
            <DsIconButton
                :aria-label="tooltipLabel"
                :name="icon"
                class="list-item-button"
                :class="{ 'list-item-button-destructive': destructive }"
                @click="$emit('click')"
                @mouseover="isTooltipOpen = true"
                @mouseleave="isTooltipOpen = false"
            />
        </template>

        <template #default>
            {{ tooltipLabel }}
        </template>
    </ds-tooltip>
</template>

<script>
export default {
    props: {
        disableTooltip: Boolean,
        icon: {
            type: String,
            required: true,
        },
        tooltipLabel: {
            type: String,
            required: true,
        },
        tooltipPosition: String,
        destructive: Boolean,
    },

    data() {
        return {
            isTooltipOpen: false,
        };
    },
};
</script>

<style lang="scss" scoped>
.list-item-button {
    display: flex;
    justify-content: center;
    align-items: center;

    --icon-color: #{$color-gray-darkest};
    --icon-size: #{px-to-rem(24)};
}

.list-item-button-destructive {
    --icon-color: #{$color-red-800};
}

.tooltop.open {
    z-index: 1000;
}
</style>
